<div (click)="openModal()" class="expense-total-widget" [class.expense-total-widget--small]="size === 'small'"
    [class.expense-total-widget--medium]="size !== 'small'">
    <div class="expense-total-widget__header">
        <div class="expense-total-widget__header-content">
            <div class="expense-total-widget__title">{{ title }}</div>
            <ng-container *ngIf="isEditMode">
                <div (click)="toggleSizeDropdown(index, $event)" class="ai-advice-widget__icon-container"
                    cdkOverlayOrigin #editTrigger="cdkOverlayOrigin">
                    <div class="ai-advice-widget__icon">
                        <img src="assets/icons/widget/pencil.svg" alt="Edit">
                    </div>
                </div>
                <!-- Size Dropdown -->
                <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
                    [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize"
                    [removeWidget]="removeWidget" [toggleSizeDropdown]="toggleSizeDropdown">
                </app-widget-edit>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                    alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
            </ng-container>
        </div>
    </div>

    <div class="expense-total-widget__content">
        <!-- Small Size - Horizontal Bars Canvas -->
        <div *ngIf="size === 'small'"
            class="expense-total-widget__canvas-container expense-total-widget__canvas-container--small">
            <canvas #smallCanvas (mousemove)="onCanvasHover($event, 'small')" (mouseleave)="hideTooltip()"></canvas>
            <div class="expense-total-widget__tooltip" *ngIf="hoveredData && tooltipVisible"
                [style.top.px]="tooltipPosition.y" [style.left.px]="tooltipPosition.x">
                <div class="expense-total-widget__tooltip-amount">{{ hoveredData.value | currency:'INR':'symbol':'1.2-2'
                    }}</div>
            </div>
        </div>

        <!-- Medium/Half/Full Size - Vertical Bars Canvas -->
        <div *ngIf="size !== 'small'"
            class="expense-total-widget__canvas-container expense-total-widget__canvas-container--medium">
            <canvas #mediumCanvas (mousemove)="onCanvasHover($event, 'medium')" (mouseleave)="hideTooltip()"></canvas>
            <div class="expense-total-widget__tooltip" *ngIf="hoveredData && tooltipVisible"
                [style.top.px]="tooltipPosition.y" [style.left.px]="tooltipPosition.x">
                <div class="expense-total-widget__tooltip-amount">{{ hoveredData.value | currency:'INR':'symbol':'1.2-2'
                    }}</div>
            </div>
        </div>
    </div>

    <!-- Top Expense Display -->
    <div class="expense-total-widget__footer" *ngIf="topExpense">
        <div class="expense-total-widget__top-label">TOP: {{ topExpense.day }}</div>
        <div class="expense-total-widget__top-amount">{{ topExpense.value | currency:'INR':'symbol':'1.2-2' }}</div>
    </div>

</div>